<primecontrol-modal-body>
  <div class="overflow-y-auto flex flex-col flex-1 min-h-0 my-4 px-6 gap-4">
    <primecontrol-input
      [control]="invitationForm?.controls['email']"
      [label]="'EMAIL' | translate"
      [placeholder]="'EMAIL' | translate"
      [type]="'email'"
    >
    </primecontrol-input>
    <primecontrol-select
      [control]="invitationForm?.controls['roleId']"
      [label]="'ROLE' | translate"
      [options]="roleOptions()"
      [placeholder]="'SELECT_ROLE' | translate"
    >
    </primecontrol-select>
  </div>
</primecontrol-modal-body>
<primecontrol-modal-footer>
  <div class="flex items-center justify-end gap-3 min-h-16">
    <primecontrol-button
      [label]="'CANCEL'"
      [icon]="'mat_solid:close'"
      [type]="'outline'"
      [hideOnMobile]="true"
      (event)="close()"
      [color]="'secondary'"
    ></primecontrol-button>

    <primecontrol-button
      [label]="'SEND'"
      [icon]="'feather:send'"
      [hideOnMobile]="true"
      (event)="sendInvitation()"
      [disabled]="invitationForm.invalid || isSending()"
      [loading]="isSending()"
      [color]="'primary'"
    ></primecontrol-button>
  </div>
</primecontrol-modal-footer>
